import { LegalAiTermsCard } from '@common/SapAiTerms/LegalCard/LegalAiTermsCard';
import { NestedData } from '@prophecy/interfaces/generic';
import { theme } from '@prophecy/theme';
import { Stack, Text, Input } from '@prophecy/ui-v3';
import { Alert, message } from '@prophecy/ui-v3/ui-compat';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import styled from 'styled-components';

import { getAboutInfo } from '../../../data/apis/api';
import { MaintenanceNotification } from '../../Maintenance/MaintenanceNotification';
import { StyledHeading } from '../config/styled';

const DisabledInput = styled(Input)`
  & > div[disabled] {
    border: none;
  }
`;

type ComponentStatusObj = {
  name: string;
  status: string;
};

type AboutData = {
  data: { version: string; componentStatus: ComponentStatusObj[] };
};

export const About = () => {
  const { data, isError, error } = useQuery<AboutData, NestedData>(['About'], () => getAboutInfo(), {
    retry: false,
    onError: (err) => {
      message.error({ content: err?.message, detail: err?.trace });
    }
  });

  const aboutData = data?.data;

  return (
    <Stack gap={theme.spaces.x24} height='100%'>
      <StyledHeading level='xl'>Prophecy IDE</StyledHeading>
      {isError && <Alert>{error?.message || 'Some error occurred.'}</Alert>}
      {aboutData && (
        <Stack gap={theme.spaces.x8}>
          <Text level='sm'>Version</Text>
          <DisabledInput value={aboutData.version} disabled data-test-id='about-version-input' />
        </Stack>
      )}
      <LegalAiTermsCard />
      {aboutData && (
        <Stack height='100%'>
          <MaintenanceNotification />
        </Stack>
      )}
    </Stack>
  );
};
